/*
 * @Author: 小周
 * @Date: 2023-09-07 11:04:17
 * @LastEditTime: 2024-08-02 09:40:08
 * @LastEditors: MrZHLF
 * @Description: 微信分享基础配置
 */

const appId = 'wx26419932e8cf3121'
const shareLink = window.location.href
const shareTitle = '2024巴黎奥运会奖牌榜'
const shareDesc = '实时更新 一键直通'
const shareImg = 'https://res.hntv.tv/icon/share-dx.png'

export { appId, shareLink, shareTitle, shareDesc, shareImg }
